// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"220":"a555a336","446":"c5afa949","496":"b0172ea5","581":"d6b5bdec","667":"81085ca1","836":"8a021a59","896":"e9e02f2d"}[chunkId] + ".chunk.js";
};